import {CoverageConfirmation} from "../../types/negotiations";
import {useState} from "react";
import {Button, Modal, Radio} from "antd";
import {useLazyGenerateRiskStatusQuery} from "../../redux/api/coverageConfirmationApiSlice";
import {DownloadOutlined} from "@ant-design/icons";

export const GenerateRiskStatus = ({coverageData} : {coverageData: CoverageConfirmation}) => {

    const [generateRS, {isLoading, isFetching}] = useLazyGenerateRiskStatusQuery()

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const [getTemplate, setGetTemplate] = useState<boolean>(false)

    return <>
        <Modal
            open={isModalOpen}
            onCancel={()=> setIsModalOpen(false)}
            title={"Scarica stato di rischio"}
            okText={"Scarica"}
            okButtonProps={{loading: isLoading || isFetching}}
            onOk={()=> {
                generateRS({uuid: coverageData.uuid, getTemplate}).unwrap()
                    .then(res => {
                        setIsModalOpen(false)
                    })
            }}
        >
            <div style={{marginBottom: 10}}>Scarica stato di rischio:</div>
            <Radio.Group value={getTemplate} onChange={v => setGetTemplate(v.target.value)}>
                <Radio value={false}>
                    Valorizzato
                </Radio>
                <Radio value={true}>
                    Template (valorizzato con dati di esempio)
                </Radio>
            </Radio.Group>
        </Modal>
        <Button
            onClick={()=> setIsModalOpen(true)}
            icon={<DownloadOutlined/>}
        >
            Stato di rischio
        </Button>
    </>
}